module.exports = require("@swa-ui/core/src/Banner/Banner.module.scss");